import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Modal, ModalButtons } from 'ui/Modal'
import { Button } from 'ui/components/Button'
import { useEditOrderItem } from 'api/OrderItems'
import {
  ApiErrorNotification,
  Notification,
  useNotificationContext,
} from 'ui/components/Notification'
import { DateTime } from 'luxon'
import { DatePicker } from 'ui/components/Form/DatePicker'

export const EditVoucherDeliveryDateOverlay = ({ onCancel, isOpen = false, item }) => {
  const title = item.item_configuration.delivery_date ? 'Edit delivery date' : 'Add delivery date'
  const { mutate, isLoading } = useEditOrderItem()
  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState(
    item.item_configuration.delivery_date !== null
      ? new Date(item.item_configuration.delivery_date)
      : DateTime.now().plus({ days: 1 }).toJSDate()
  )
  const notification = useNotificationContext()
  const { orderId } = useParams()

  const handleSave = () => {
    mutate(
      [
        orderId,
        item.id,
        {
          item_configuration: {
            delivery_date: selectedDeliveryDate,
          },
        },
      ],
      {
        onSuccess: () => {
          notification.notify(
            <Notification
              title="Delivery date updated"
              description="The delivery date was successfully updated"
              variant="success"
              autoDismiss
            />
          )
          onCancel()
        },
        onError: (error) => {
          notification.notify(<ApiErrorNotification error={error} />)
        },
      }
    )
  }

  return (
    <Modal title={title} isOpen={isOpen} onClose={onCancel} styleReset size="sm">
      <div>
        <DatePicker
          inline
          value={selectedDeliveryDate}
          onChange={(value) => {
            setSelectedDeliveryDate(value)
          }}
          minDate={DateTime.now().plus({ days: 1 }).toJSDate()}
        />
        <ModalButtons>
          <Button variant="primary" onClick={handleSave} label="Update" loading={isLoading} />
          <Button onClick={onCancel} label="Cancel" />
        </ModalButtons>
      </div>
    </Modal>
  )
}
